import store from 'store2';
import { useDispatch } from 'react-redux';
import { useSnackbar } from 'notistack';
import Router from './routes';
import ThemeProvider from './theme';
import ScrollToTop from './components/scroll-to-top';
import { StyledChart } from './components/chart';
import { appSliceActions } from './appSlices/appSlice';
import fetchDeviceList from './utils/fetchDeviceList';
import fetchStreamList from './utils/fetchStreamList';
import getPublicIpAddr from './utils/getPublicIpAddress';
import { VstAdaptorWrapper } from './components/vst-adaptor-wrapper/vstAdaptorWrapper';

import './App.css';

/**
 * VST UI supports multiple VST devices in different physical locations. Operations are supported on these
 * devices. VST UI maintains the host of these devices in persistant storage. At boot of UI, if current
 * host is not saved, then save it and then load the UI.
 */

export default function App() {
  console.log('VST adaptor type is: ', window.adaptorType);
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();
  let storedhosts = store('hosts');
  console.log('storedhosts: ', storedhosts);
  if (storedhosts == null) {
    console.debug('no saved hosts found');
    dispatch(appSliceActions.addVstHost(window.location.host));
    console.debug('saved', window.location.host);
  } else {
    console.debug('hosts found: ');
    storedhosts.forEach((host, index) => {
      dispatch(appSliceActions.addVstHost(window.location.host));
      console.debug(`${index}: ${host}`);
    });
  }
  // fetch and store devices and streams information for each VST device
  storedhosts = store('hosts');
  storedhosts.forEach(async (host) => {
    // add hosts from localStorage to redux storage
    dispatch(appSliceActions.addVstHost(host));
    // populate devices and streams
    const sensorList = await fetchDeviceList(host);
    if (sensorList != null) {
      for (let i = 0; i < sensorList.length; i += 1) {
        sensorList[i].host = host;
      }
      dispatch(appSliceActions.addDevice(sensorList));
    }
    const streamList = await fetchStreamList(host);
    if (streamList != null) {
      for (let i = 0; i < streamList.length; i += 1) {
        streamList[i].host = host;
      }
      dispatch(appSliceActions.addStream(streamList));
    }
  });

  console.log(`Getting public IP address of client...`);
  getPublicIpAddr()
    .then(ip => {
      dispatch(appSliceActions.setPublicIp(ip));
      console.log(`Done, IP is: `, ip);
      if (ip == null) {
        enqueueSnackbar(`Error - Failed to get client public address`, {
          variant: 'error',
          anchorOrigin: { horizontal: 'right', vertical: 'bottom' },
        });
      }
    })
    .catch(error => {
      enqueueSnackbar(`Error - Failed to get client public address`, {
        variant: 'error',
        anchorOrigin: { horizontal: 'right', vertical: 'bottom' },
      });
      console.error(`Error getting public IP address: ${error.message}`);
    });

  return (
    <ThemeProvider>
      <VstAdaptorWrapper>
        <ScrollToTop />
        <StyledChart />
        <Router />
      </VstAdaptorWrapper>
    </ThemeProvider>
  );
}
